export default __webpack_public_path__ + "static/media/customer-support.a8b0cfbd.jpg";